import { useState, useEffect, useCallback } from 'react';
import { prototypesApi } from '@infrastructure/api';
export function usePrototypes() {
    const [prototypes, setPrototypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchPrototypes = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const data = await prototypesApi.list();
            setPrototypes(data);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to load prototypes';
            setError(message);
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchPrototypes();
    }, [fetchPrototypes]);
    const registerPrototype = useCallback(async (name, githubRepoUrl, description) => {
        const newPrototype = await prototypesApi.register({ name, githubRepoUrl, description });
        setPrototypes((prev) => [...prev, newPrototype]);
        return newPrototype;
    }, []);
    const deployPrototype = useCallback(async (id) => {
        const result = await prototypesApi.deploy(id);
        setPrototypes((prev) => prev.map((p) => (p.id === id ? result.prototype : p)));
    }, []);
    const deletePrototype = useCallback(async (id) => {
        await prototypesApi.delete(id);
        setPrototypes((prev) => prev.filter((p) => p.id !== id));
    }, []);
    return {
        prototypes,
        isLoading,
        error,
        refetch: fetchPrototypes,
        registerPrototype,
        deployPrototype,
        deletePrototype,
    };
}
